import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

const TelomereTestingPage = () => {
  const navigate = useNavigate();
  const { user } = useUser();
  
  const [isLoading, setIsLoading] = useState(false);
  const [testResult, setTestResult] = useState(null);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  
  // 如果用户未登录，重定向到登录页面
  if (!user) {
    navigate('/login');
    return null;
  }
  
  // 模拟提交表单
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setHasSubmitted(true);
    
    // 模拟网络请求延迟
    setTimeout(() => {
      // 生成随机测试结果
      const biologicalAge = Math.floor(Math.random() * 10) + 20;
      const chronologicalAge = 30; // 假设实际年龄
      const telomereLength = (Math.random() * 2 + 6).toFixed(2);
      const healthScore = Math.floor(Math.random() * 30) + 70;
      
      setTestResult({
        biologicalAge,
        chronologicalAge,
        telomereLength,
        healthScore,
        recommendations: [
          '每日进行冥想修炼，稳定灵力循环',
          '服用筑基丹，强化基础',
          '坚持体魄锻炼，增强肉身强度'
        ]
      });
      
      setIsLoading(false);
    }, 3000);
  };
  
  return (
    <div className="space-y-8">
      <section className="cyber-panel p-6 rounded-lg bg-gradient-to-r from-cyber-dark to-black">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div>
            <h1 className="text-3xl font-xianxia text-cyber-primary mb-2 cyber-title">端粒长度检测</h1>
            <p className="text-cyber-light">
              通过分析DNA端粒长度，评估您的生物学年龄和潜在寿命
            </p>
          </div>
        </div>
      </section>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="md:col-span-1">
          <div className="cyber-panel p-6 rounded-lg">
            <h2 className="text-xl font-cyber text-cyber-primary mb-4">
              什么是端粒检测？
            </h2>
            
            <p className="text-cyber-light text-sm mb-4">
              端粒是染色体末端的保护性结构，随着细胞分裂和年龄增长而缩短。端粒长度被认为是生物学年龄的重要指标，
              通过测量端粒长度，可以评估您的真实生物学年龄和潜在寿命。
            </p>
            
            <p className="text-cyber-light text-sm mb-4">
              天道宗结合传统修真与现代生物技术，通过特殊方法检测您的端粒长度，为您提供个性化的修炼建议。
            </p>
            
            <div className="cyber-panel p-4 rounded">
              <h3 className="text-lg text-cyber-secondary mb-2">
                检测优势
              </h3>
              <ul className="text-cyber-light text-sm space-y-2">
                <li>• 科学评估生物学年龄</li>
                <li>• 定制个人修炼方案</li>
                <li>• 追踪修炼成效</li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="md:col-span-2">
          {!hasSubmitted ? (
            <div className="cyber-panel p-6 rounded-lg">
              <h2 className="text-xl font-cyber text-cyber-primary mb-6">
                提交检测申请
              </h2>
              
              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <label className="block text-cyber-light mb-2">
                    实际年龄
                  </label>
                  <input
                    type="number"
                    min="18"
                    max="100"
                    className="w-full bg-cyber-dark border border-cyber-primary text-cyber-light px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-cyber-accent"
                    placeholder="请输入您的实际年龄"
                    required
                  />
                </div>
                
                <div className="mb-4">
                  <label className="block text-cyber-light mb-2">
                    修炼年限
                  </label>
                  <input
                    type="number"
                    min="0"
                    max="50"
                    className="w-full bg-cyber-dark border border-cyber-primary text-cyber-light px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-cyber-accent"
                    placeholder="请输入您的修炼年限"
                    required
                  />
                </div>
                
                <div className="mb-6">
                  <label className="block text-cyber-light mb-2">
                    主要修炼功法
                  </label>
                  <select
                    className="w-full bg-cyber-dark border border-cyber-primary text-cyber-light px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-cyber-accent"
                    required
                  >
                    <option value="">请选择主要修炼功法</option>
                    <option value="qigong">基础气功</option>
                    <option value="meditation">冥想修炼</option>
                    <option value="martial">武技修炼</option>
                    <option value="alchemy">丹药炼制</option>
                    <option value="cyber">赛博修炼</option>
                  </select>
                </div>
                
                <div className="text-center">
                  <button
                    type="submit"
                    className="cyber-button px-8 py-3"
                  >
                    提交申请
                  </button>
                </div>
              </form>
            </div>
          ) : (
            <div className="cyber-panel p-6 rounded-lg">
              {isLoading ? (
                <div className="text-center py-12">
                  <div className="text-cyber-primary text-3xl mb-4">
                    <i className="fas fa-spinner fa-spin"></i>
                  </div>
                  <p className="text-cyber-light">DNA端粒分析中，请稍候...</p>
                </div>
              ) : (
                <>
                  <h2 className="text-xl font-cyber text-cyber-primary mb-6">
                    检测结果
                  </h2>
                  
                  <div className="grid grid-cols-2 gap-4 mb-6">
                    <div className="cyber-panel p-4 rounded text-center">
                      <div className="text-sm text-cyber-light mb-1">生物学年龄</div>
                      <div className="text-3xl text-cyber-accent">{testResult.biologicalAge}</div>
                      <div className="text-xs text-cyber-light mt-1">实际年龄: {testResult.chronologicalAge}</div>
                    </div>
                    
                    <div className="cyber-panel p-4 rounded text-center">
                      <div className="text-sm text-cyber-light mb-1">端粒长度</div>
                      <div className="text-3xl text-cyber-accent">{testResult.telomereLength} kb</div>
                      <div className="text-xs text-cyber-light mt-1">正常范围: 5.8-8.5 kb</div>
                    </div>
                  </div>
                  
                  <div className="cyber-panel p-4 rounded mb-6">
                    <h3 className="text-lg text-cyber-secondary mb-3">健康评分</h3>
                    <div className="relative pt-1">
                      <div className="overflow-hidden h-4 mb-1 text-xs flex rounded bg-cyber-dark">
                        <div
                          style={{ width: `${testResult.healthScore}%` }}
                          className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-cyber-primary"
                        ></div>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-xs text-cyber-light">{testResult.healthScore}分</span>
                        <span className="text-xs text-cyber-light">100分</span>
                      </div>
                    </div>
                  </div>
                  
                  <div>
                    <h3 className="text-lg text-cyber-secondary mb-3">修炼建议</h3>
                    <ul className="cyber-panel p-4 rounded space-y-2">
                      {testResult.recommendations.map((recommendation, index) => (
                        <li key={index} className="flex items-start">
                          <i className="fas fa-angle-right text-cyber-primary mt-1 mr-2"></i>
                          <span className="text-cyber-light">{recommendation}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TelomereTestingPage;
